/* globals window */
import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import LanguageIcon from '@material-ui/icons/Language';
import { PropTypes } from 'prop-types';

const LanguageSwitch = ({ t }) => {
  const { i18n } = useTranslation();
  const changeLanguage = ({ popupState, value }) => {
    i18n.changeLanguage(value);
    window.localStorage.setItem('defaultLanguage', value);
    popupState.close();
  };
  return (
    <PopupState variant="popover" popupId="languahe-popup-menu">
      {popupState => (
        <React.Fragment>
          <Button testid="langSelector" variant="contained" {...bindTrigger(popupState)}>
            {t('switchLanguage')} <LanguageIcon style={{ marginLeft: '0.3em' }} />
          </Button>
          <Menu {...bindMenu(popupState)}>
            <MenuItem testid="english" onClick={() => changeLanguage({ popupState, value: 'en' })}>
              english
            </MenuItem>
            <MenuItem testid="spanish" onClick={() => changeLanguage({ popupState, value: 'es' })}>
              español
            </MenuItem>
            <MenuItem testid="french" onClick={() => changeLanguage({ popupState, value: 'fr' })}>
              français
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
};

LanguageSwitch.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation()(LanguageSwitch);
